class Teacher {
  constructor() {
    this.props = {
      jsteacher: document.querySelector('.js-teacher'),
      teacher: document.querySelector('.teacher'),
      closeBtn: document.querySelector('.js-close-teacher'),
      teacherList: document.querySelector('.js-teacher-list'),
      readMore: document.querySelector('.js-teacher-read'),
    };

    this.bind();
  }
  bind() {

    const { readMore } = this.props;

    if ( readMore ) {
      readMore.addEventListener('click', e => {
        this.readMore();
      });
    }

  }
  readMore() {
    const { teacher, readMore } = this.props;
    if ( teacher ) {
      const descContainer = teacher.querySelector('.teacher__description--desktop');
      descContainer.classList.toggle('teacher__description--show');

      if (descContainer.classList.contains('teacher__description--show')) {
        readMore.innerText = readMore.getAttribute('data-read-less');
      } else {
        readMore.innerText = readMore.getAttribute('data-read-more');
      }

    }
  }
  closeTeacher() {
    this.props.jsteacher.classList.add('groupLessonTeacher--close');
    this.props.teacherList.classList.add('groupLessonTeachers--close');
  }
}

export default Teacher;